import * as React from 'react';
import { SVGProps } from 'react';

const IconDinosaurSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 1h-4v.5H6V5H5v.5H4V6h-.5v.4H3V6H2V4.8H1V7h1v1h1v3h2v-1H4V9h.5v-.5h1V9H6v2h2v-1H7V7h1V6h.5v.5H9v-1H8V5h2v-.6H8.5v-.9H11v-2h-.5V1zm-3 1.5H8V2h-.5v.5z"
    />
  </svg>
);
export default IconDinosaurSizeXs;
